import React from "react"

export const RichTextContext = React.createContext<{ isInRichText: boolean }>({
  isInRichText: false
})

export const useRichTextContext = () => React.useContext(RichTextContext)
